import { Injectable } from "@angular/core";

const STORAGE_KEY = "ipa.inviteToken";

/** Query params worth carrying between the invite pages and to login (b2c, dev, ...), never the token. */
export function forwardedInviteQueryParams(): Record<string, string> {
  const params: Record<string, string> = {};
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (key !== "token") params[key] = value;
  });
  return params;
}
const TTL_MS = 30 * 60 * 1000;

/**
 * Holds the invitation token between /invite (validation) and /invite/set-password, so the token
 * is never in the set-password URL and a page refresh doesn't lose it. sessionStorage: this tab
 * and origin only, gone when the tab closes, cleared as soon as the invitation is finished.
 */
@Injectable({ providedIn: "root" })
export class InviteSessionService {
  public store(token: string): void {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ token, expiresAt: Date.now() + TTL_MS }));
    } catch (err) {
      console.warn("InviteSessionService.store - sessionStorage unavailable.", err);
    }
  }

  public get token(): string | null {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const { token, expiresAt } = JSON.parse(raw);
      if (typeof token !== "string" || !expiresAt || expiresAt < Date.now()) {
        this.clear();
        return null;
      }
      return token;
    } catch {
      return null;
    }
  }

  public clear(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // nothing to clean up
    }
  }
}
